<div class="sign-up-container">
  <h1>{{ "sign-up-page.TITLE" | translate }}</h1>
  <form [formGroup]="applyForm" (ngSubmit)="submit()">
    <div class="form-group">
      <label for="email">{{ "sign-up-page.EMAIL_LABEL" | translate }}</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        required
        (input)="resetAccountExists()"
        (blur)="setEmailTouched()"
      />
      <div
        *ngIf="
          applyForm.get('email')?.hasError('required') &&
          applyForm.get('email')?.touched
        "
      >
        <span class="error-message">{{
          "sign-up-page.EMAIL_REQUIRED" | translate
        }}</span>
      </div>
      <div
        *ngIf="
          applyForm.get('email')?.hasError('email') &&
          applyForm.get('email')?.touched
        "
      >
        <span class="error-message">{{
          "sign-up-page.EMAIL_INVALID" | translate
        }}</span>
      </div>
    </div>

    <div *ngIf="accountExists" class="error-message" style="color: red">
      {{ "sign-up-page.ACCOUNT_EXISTS" | translate }}
    </div>

    <div class="form-group">
      <label for="mobile-number">{{
        "sign-up-page.MOBILE_LABEL" | translate
      }}</label>
      <input id="mobile-number" type="text" formControlName="mobile_number" />
      <div
        *ngIf="
          applyForm.get('mobile_number')?.hasError('required') &&
          applyForm.get('mobile_number')?.touched
        "
      >
        <span class="error-message">{{
          "sign-up-page.MOBILE_REQUIRED" | translate
        }}</span>
      </div>
      <div
        *ngIf="
          applyForm.get('mobile_number')?.hasError('pattern') &&
          applyForm.get('mobile_number')?.touched
        "
      >
        <span class="error-message">{{
          "sign-up-page.MOBILE_INVALID" | translate
        }}</span>
      </div>
    </div>

    <div class="form-group">
      <label for="password">{{
        "sign-up-page.PASSWORD_LABEL" | translate
      }}</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        required
        *ngIf="!applyForm.get('password')?.disabled"
      />
      <div *ngIf="applyForm.hasError('passwordMismatch')">
        <span class="error-message">{{ passwordMismatchError }}</span>
      </div>
      <div *ngIf="applyForm.hasError('passwordComplexity')">
        <span class="error-message">{{ passwordComplexityError }}</span>
      </div>
    </div>

    <div class="form-group">
      <label for="confirm-password">{{
        "sign-up-page.CONFIRM_PASSWORD_LABEL" | translate
      }}</label>
      <input
        id="confirm-password"
        type="password"
        formControlName="confirm_password"
        required
        *ngIf="!applyForm.get('password')?.disabled"
      />
    </div>

    <button type="submit" class="primary">
      {{ "sign-up-page.SUBMIT_BUTTON" | translate }}
    </button>
  </form>
</div>
